<template lang="pug">
#modal-deposit.modal.fade(tabindex='-1' role='dialog')
  .modal-dialog.modal-dialog-centered.my-0.modal-form
    .modal-content-outside.modal-bg
      .modal-content
        //- .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(onclick='location.href='index-logged-in.html'')
        template(v-if="showPromo")
          .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(@click="closePromo")
            .arrow-left
              i.fas.fa-chevron-left
            .modal-title.text-capitalize 
          .d-none.d-md-block.lg-close(@click="closePromo")
            i.far.fa-times-circle
          .modal-body.px-2
            .tab-statement.pt-md-4
              ul#pills-tab-bonus.nav.nav-pills.mb-3(role='tablist')
                li.nav-item.col.px-1(role='presentation')
                  a#pills-tab-bonus01.nav-link.active(data-toggle='pill' href='#pills-bonus01' role='tab' aria-controls='pills-bonus01' aria-selected='true') {{$t('ui.promotions')}}
                //- li.nav-item.col-4.px-1(role='presentation')
                //-   a#pills-tab-bonus02.nav-link(data-toggle='pill' href='#pills-bonus02' role='tab' aria-controls='pills-bonus02' aria-selected='false') daily bonus
                //- li.nav-item.col-4.px-1(role='presentation')
                //-   a#pills-tab-bonus03.nav-link(data-toggle='pill' href='#pills-bonus03' role='tab' aria-controls='pills-bonus03' aria-selected='false') vip bonus
              #pills-tabBonusContent.tab-content
                #pills-bonus01.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='ppills-tab-bonus01')
                  .d-flex.align-items-center.bonus-single(@click="selectPromo(0)")
                    .icon-bonus
                      img(src='img/icon-bonus.svg')
                    .flex-grow-1.bonus-value
                      .font-weight-bold.bonus-title {{$t('ui.promo_none')}}
                    .btn-bonus {{$t('ui.back')}}
                  .d-flex.align-items-center.bonus-single.pointer(v-for="promo in getPromoList" @click="selectPromo(promo.promotion_id)")
                    .icon-bonus
                      img(src='img/icon-bonus.svg')
                    .flex-grow-1.bonus-value
                      .font-weight-bold.bonus-title {{promo.promotion_name}}
                      .bonus-detail Bonus - {{promo.bonus_rate}} Rollover - {{promo.rollover}}
                    .btn-bonus {{promo.min_deposit}}
                //- #pills-bonus02.tab-pane.fade(role='tabpanel' aria-labelledby='pills-tab-bonus02')
                //- #pills-bonus03.tab-pane.fade(role='tabpanel' aria-labelledby='pills-tab-bonus03')
        template(v-else)
          .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(data-dismiss='modal')
            .arrow-left
              i.fas.fa-chevron-left
            .modal-title.text-capitalize home
          .d-none.d-md-block.lg-close(data-dismiss='modal')
            i.far.fa-times-circle       
          .modal-body.m-negative
            .text-center
              .text-uppercase.modal-form-title deposit
            .d-flex.justify-content-center.btn-balance.btn-shadow.w-50.my-4.no-pointer
              div
                .text-white.text-uppercase.text-balance {{$t('ui.balance')}}
                .text-success.balance-value {{ $numeral($store.getters.balance).format("0,0.00") }}
            .tab-statement.pt-0
              ul#pills-tabDeposit.nav.nav-pills.mb-3(role='tablist')
                //- li.nav-item.col-6.px-2(role='presentation')
                  a#pills-ibank-tab.nav-link.active(data-toggle='pill' href='#pills-ibank' role='tab' aria-controls='pills-ibank' aria-selected='true') bank
                li.nav-item.col.px-2(role='presentation')
                  a#pills-manual-tab.nav-link.active.no-pointer(data-toggle='pill' href='#pills-manual' role='tab' aria-controls='pills-manual' aria-selected='false') online transfer
              #pills-tabDepositContent.tab-content
                manualDeposit(@showPromoList="showPromoList" :minDeposit="minDeposit")   
                //- manualDeposit(:welcomeBonus="welcomeBonus" :dailyBonus="dailyBonus" :vipBonus="vipBonus" :promoSelected="promoSelected" @showPromoList="showPromoList")     
</template>
<script>
import config from "@/config"
import manualDeposit from "@/component/_manualDeposit.vue"
export default {
  components:{
    manualDeposit,
  },
  data(){
    return{
      conditionChecked: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      bankModeList: [],
      // ibankActiveList: [],
      minDeposit: 0,
      minWithdrawal: 0,
      promoList: [],
      welcomeBonus:[],
      dailyBonus: [],
      vipBonus: [],
      operatorBankList: [],
      showPromo: false,
      promoSelected: [],
      tabTarget: 'MANUAL',
      bankId: "",
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getPromoList(){
      return this.$store.getters.promoList.data.PROMOTION_LIST
    },
    getPromoSelected(){
			return this.$store.getters.promoSelected
		}
  },
  created(){
    
  },
  mounted(){
    var vm = this;
    $("#modal-deposit").on("show.bs.modal", function() {
      vm.getPromo()
    })
  },
  methods:{
    closePromo(){
      this.showPromo = false
    },
    showPromoList(e){
      this.showPromo = true;
    },
    selectPromo(id){
      if(id == 0){
        this.$store.dispatch("user/setPromoSelected", "")
        this.minDeposit = 0
      }else{
        this.promoSelected = []
        this.$store.dispatch("user/setPromoSelected", id)
        this.getPromoList.filter(x => x.promotion_id == this.getPromoSelected).forEach(y => {
          this.promoSelected.push(y)
        })
        this.$store.dispatch("user/setPromoDetail", this.promoSelected)
        this.minDeposit = this.promoSelected[0].min_deposit
        
      }
      this.closePromo()
      
    },
    getPromo(){
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getPromo", { member_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sPromo", { data: response.data })
                .then(() => {
                  
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
  }
}
</script>